import React from "react";
import "./TextField.css";
import { svgIcons } from "../../../style/fonts/SvgIcons";

interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  leftLabel?: string;
  labelClass?: string;
  fieldClass?: string;
  required?: boolean;
  icon?: any;
  fieldIcon?: any;
  class?: any;
  formik?: any; // Add Formik support
  name?: string; // Ensure name is passed for Formik
}

const NumberField: React.FC<TextFieldProps> = ({
  label,
  leftLabel,
  labelClass = "",
  type = "text",
  id,
  value,
  checked,
  fieldClass = "",
  placeholder,
  onChange,
  required,
  icon,
  fieldIcon,
  formik,
  name,
  ...fieldProps
}) => {
  // Function to format numbers with commas
  const formatNumber = (num: string) => {
    const numericValue = num.replace(/,/g, ""); 
    if (isNaN(Number(numericValue))) return num; 
    return Number(numericValue).toLocaleString(); 
  };

  // Function to handle input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/,/g, "");
    if (!isNaN(Number(rawValue)) && rawValue !== "") {
      formik?.setFieldValue(name, Number(rawValue)); 
    }
  };

  return (
    <div
      className={`${
        leftLabel ? "d-md-flex w-100 justify-content-between align-items-center " : ""
      }`}
    >
      {label || leftLabel ? (
        <label
          className={`input-label text-nowrap ${labelClass} ${required ? "required" : ""} ${
            leftLabel ? "w-50" : ""
          }`}
        >
          <div>
            <span className="">{icon}</span>
            {label}
            {leftLabel}
            {required && <span className="required-star text-danger ms-1">*</span>}
          </div>
        </label>
      ) : null}
      <div className={`position-relative ${leftLabel ? "w-50" : ""}`}>
        {fieldIcon === true && (
          <i className="icon2 position-absolute ms-2" style={{ top: "9px" }}>
            {svgIcons.dollarIcon}
          </i>
        )}
        <input
          type="text" // Keep type as text to support commas
          className={`${
            type !== "checkbox" ? "form-control form-control-solid default-inputs" : ""
          } ${fieldIcon === true ? "ps-4" : ""} ${fieldClass} `}
          placeholder={placeholder}
          onChange={handleInputChange}
          id={id}
          value={formatNumber(value?.toString() || "")} // Display formatted number
          checked={checked}
          {...fieldProps}
        />
      </div>
    </div>
  );
};

export default NumberField;

export const inputMaskNumber='___-___-____'